import  { useEffect, useState } from "react";
import AdminDashboardComponents from "../../components/HigherOrderComponents/AdminDashboardComponents";
import { toast } from "react-toastify";
import { deleteMaterial, getAllMaterialData, upsertMaterial } from "../../utils/actions/adminActions";
import { useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";
import { ArrowLeft, ArrowUpIcon } from "../../components/Icons";
import useDocumentTitle from "../../utils/useDocumentTitle";
import { AutoComplete, Select, Input } from 'antd';
import { getAllCNCMaterialMaster } from "../../api/customer/masters/adminMastersApi";
import { Modal } from 'antd';
import { useInstance } from "../../context/instance.context";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";


const { Option } = Select;

const MaterialMasterComponent = () => {
    const [materialOptions, setMaterialOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useDocumentTitle('Material cnc');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allMaterialsData, setAllMaterialsData] = useState([]);
    const [filteredMaterialsData, setFilteredMaterialsData] = useState([]);
    const { organizationCurrencySymbol } = useInstance();
    const [hardeningScaleArray, setHardeningScaleArray] = useState([])

    const [isReload, setIsReload] = useState();
    const [formData, setFormData] = useState({
        cnc_material: "",
        cnc_grade: "",
        cnc_material_desc: "",
        cnc_material_density_gms_cm3: "",
        cnc_material_review: "false",
        cnc_hardening: '',
        cnc_hardening_scale: '',
        cnc_material_number: '',
    });
    const location = useLocation();

    const [materialSortingType, setMaterSortingType] = useState(() => {
        // Try to get the stored sort type for the current pathname
        const savedSortType = sessionStorage.getItem(location.pathname + 'sort');
        return savedSortType || 'aced'; // Fallback to 'aced' if nothing is stored
    });
    console.log("Data sortin ::", materialSortingType);

    const [searchText, setSearchText] = useState("");

    console.log('formData ::', formData);


    function resetData() {
        const number = allMaterialsData.length + 1;
        const materialNumber = `MAT${number.toString().padStart(3, '0')}`;
        setFormData({
            cnc_material: "",
            cnc_grade: "",
            cnc_material_desc: "",
            cnc_material_density_gms_cm3: "",
            cnc_material_review: "false",
            cnc_hardening: '',
            cnc_hardening_scale: '',
            cnc_material_number: materialNumber,
        });
    }

    useEffect(() => {

        (async () => {
            try {

                setLoading(true);
                const resposne = await getAllMaterialData();
                if (!resposne || !resposne.success) {
                    throw new Error();
                }
                const { data } = resposne;
                if (Array.isArray(data)) {
                    const materialOptions = new Set([...data.map((item) => item?.cnc_material)]);
                    const hardeningScale = new Set([...data.map((item) => item?.cnc_hardening_scale).filter(Boolean)]);
                    setHardeningScaleArray([...hardeningScale] || []);
                    setMaterialOptions([...materialOptions] || []);

                }
                setAllMaterialsData(data);
            } catch (error) {
                toast.error("Failed to fetch materials");
            } finally {
                setLoading(false);
            }

        })();


    }, [isReload])


    const toggleMaterialSorting = () => {
        setMaterSortingType(prev => {
            const newSortType = prev === 'aced' ? 'decd' : 'aced';
            // Save the new sort type to sessionStorage based on the current pathname
            sessionStorage.setItem(location.pathname + 'sort', newSortType);
            return newSortType;
        });
    };




    const navigate = useNavigate();


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        //check material and also find gradeId
        setFormData({
            ...formData,
            [name]: value,
        });

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await upsertMaterial(formData);
            if (!response || !response.success) {
                throw new Error();
            };
            toast.success(`Material ${formData?._id ? "updated" : "created"} succesfully`);
        } catch (error) {
            toast.error("Unable to add Material ");
        }
        finally {
            setIsModalOpen(false);
            resetData();
            setIsReload(pre => !pre);
        }


    };

    const handleDelete = (item) => {
        const { _id } = item;

        Modal.confirm({
            title: 'Confirm Deletion',
            content: 'Are you sure you want to delete this material?',
            okText: 'Yes',
            cancelText: 'No',
            async onOk() {
                try {
                    const response = await deleteMaterial(_id);
                    if (!response || !response.success) {
                        throw new Error();
                    }

                    toast.success("Item deleted successfully");
                    setIsReload((prev) => !prev);
                } catch (error) {
                    toast.error("Unable to delete item");
                }
            },
            onCancel() {
                console.log('Deletion cancelled');
            },
        });
    };


    const handleUpdate = (item) => {
        setFormData(item);
        setIsModalOpen(true);
    };


    useEffect(() => {
        if (location.search.includes("search=")) {
            const searchParams = new URLSearchParams(location.search);
            setSearchText(searchParams.get("search"));
        }
        else {
            setSearchText("");
        }
        const storedSortType = sessionStorage.getItem(location.pathname + 'sort');
        if (storedSortType) {
            setMaterSortingType(storedSortType);
        }

    }, [location.pathname])

    useEffect(() => {
        if (searchText) {
            navigate("?search=" + searchText, { replace: true });
        }
        else {
            navigate(location.pathname, { replace: true })
        }
        console.log("All Materials Data :", allMaterialsData);

        const filterData = allMaterialsData.filter(item => {
            console.log("Data ::", item);
            return item?.cnc_material?.toLowerCase().includes(searchText.toLowerCase()) ||
                item?.cnc_grade.toLowerCase().includes(searchText.toLowerCase()) || item?.cnc_material_number?.toLowerCase().includes(searchText.toLowerCase())
        });

        filterData.sort((a, b) => {
            const sortOrder = materialSortingType === "aced" ? 1 : -1;

            const aNumber = parseInt(a.cnc_material_number?.replace("MAT", ""));
            const bNumber = parseInt(b.cnc_material_number?.replace("MAT", ""));

            return (aNumber - bNumber) * sortOrder;
        });


        setFilteredMaterialsData(filterData);

    }, [searchText, allMaterialsData, materialSortingType]);


    const handleCalculateIndex = (e) => {

        const val = e.target.value;
        const count = allMaterialsData.filter((item) => item?.cnc_material?.toLowerCase() == val?.toLowerCase()).length;
        const index = +(1 + (count + 1) / 100).toFixed(2);
        setFormData((pre) => {
            return { ...pre, cnc_index: index };
        });

    }


    return (
        <div className="w-screen relative my-2">
            <div className="flex items-center justify-between px-3">
                <BackButton
                    additionalClasses='mx-2 my-2'
                />
                <h2 className="font-bold my-4 text-center text-2xl">Materials</h2>
                <GenericLoaderComponent
                    isLoading={loading}
                />
                <button
                    onClick={() => {
                        resetData();
                        setIsModalOpen(true);
                    }}
                    className="bg-primaryColor rounded  px-2 py-2 text-sm text-white"
                >
                    Create New
                </button>
            </div>

            <form class="max-w-lg mx-auto my-2">
                <label for="default-search" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                <div class="relative">
                    <input value={searchText} onChange={(e) => setSearchText(e.target.value)} type="search" id="default-search" class="block w-full py-3  ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:border focus:border-primaryColor  " placeholder="Search " required />
                </div>
            </form>

            <table class="table-auto  w-full border-collapse border border-gray-200 shadow-lg rounded-lg overflow-hidden">
                <thead class="bg-gray-100 text-gray-600 uppercase text-sm font-semibold">
                    <tr>
                        <th class=" flex items-center h-16 px-4 py-2 border  border-gray-200">
                            <span className="whitespace-nowrap">Material no.</span>
                            <span onClickCapture={toggleMaterialSorting}>
                                <ArrowUpIcon
                                    additionalClasses={`${materialSortingType != 'aced' ? 'rotate-180' : ''} h-5`}
                                />
                            </span> </th>
                        <th class="px-4 py-2  border-gray-200  "><span>Material</span>

                        </th>
                        <th class="px-4 py-2 border border-gray-200"><span>Grade</span>

                            {/* <span onClick={toggleGradeSorting}>
                                <ArrowUpIcon
                                    additionalClasses={`${gradeSortingType == 'aced' ? 'rotate-180' : ''} h-5`}
                                />
                            </span> */}


                        </th>
                        <th class="px-4 py-2 border border-gray-200">Description </th>
                        <th class="px-4 py-2 border border-gray-200">Density (g/cm³) </th>
                        <th class="px-4 py-2 border border-gray-200">Hardening</th>
                        <th class="px-4 py-2 border border-gray-200">Hardening scale</th>
                        <th class="px-4 py-2 border border-gray-200">Manual Review </th>
                        <th class="px-4 py-2 border border-gray-200"> Parameters </th>
                        <th class="px-4 py-2 border border-gray-200">Cost Model {organizationCurrencySymbol}</th>
                        <th class="px-4 py-2 border border-gray-200">Actions </th>
                    </tr>
                </thead>
                <tbody>
                    {filteredMaterialsData.length
                        ? filteredMaterialsData.map((item, index) => (
                            <tr
                                key={index}
                                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                                    } hover:bg-gray-200 transition duration-200`}
                            >
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_material_number || ""}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_material}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_grade}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_material_desc}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_material_density_gms_cm3}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_hardening}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_hardening_scale}
                                </td>
                                <td className="px-4 py-2 border border-gray-200">
                                    {item.cnc_material_review ? "true" : "false"}
                                </td>
                                <td className="px-4 py-2 border border-gray-200 text-white">
                                    <button onClick={() => navigate('/admin/cnc/select-sub-materials', { state: item })} className='bg-yellow-500 rounded mx-2 p-1'>
                                        Select
                                    </button>
                                </td>
                                <td className="px-4 py-2 border border-gray-200 text-white">
                                    <button onClick={() => navigate('/admin/cnc/material-options', { state: item })} className='bg-yellow-500 rounded mx-2 p-1'>
                                        Configure
                                    </button>
                                </td>
                                <td className="px-4 py-2  border border-gray-200 flex-col flex text-[14px] text-white">
                                    <button onClick={() => handleUpdate(item)} className='bg-yellow-500 rounded mx-2 p-1'>
                                        Update
                                    </button>
                                    <button onClick={() => handleDelete(item)} className='bg-red-500 rounded mx-2 p-1 my-1'>
                                        Del
                                    </button>
                                </td>
                            </tr>
                        ))
                        : (
                            <tr>
                                <td
                                    colSpan="3"
                                    className="px-4 py-2 text-center text-gray-500 border border-gray-200"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                </tbody>
            </table>

            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded w-1/3">
                        <h3 className="text-lg font-bold mb-4">{formData?._id ? "Update" : "Create New"} material</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-1">
                                <label className="block text-sm font-medium ">Material no.</label>
                                <input
                                    type="text"
                                    name="cnc_material_number"
                                    value={formData.cnc_material_number}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded"
                                    required
                                />
                            </div>
                            <div className="mb-1">
                                <label className="block text-sm font-medium ">Material Name</label>
                                <AutoComplete
                                    onBlur={handleCalculateIndex}
                                    options={materialOptions.map((name) => ({ value: name }))}
                                    placeholder="Enter or select a material"
                                    value={formData.cnc_material || ''}
                                    onChange={(value) => {
                                        handleInputChange({
                                            target: {
                                                name: 'cnc_material',
                                                value,
                                            },
                                        });
                                    }}
                                    filterOption={(inputValue, option) =>
                                        option?.value.toLowerCase().includes(inputValue.toLowerCase())
                                    }
                                    className="w-full"
                                />
                            </div>

                            <div className="mb-1">
                                <label className="block text-sm font-medium ">Grade</label>
                                <input
                                    type="text"
                                    name="cnc_grade"
                                    value={formData.cnc_grade}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded"
                                    required
                                />
                            </div>
                            <div className="mb-1">
                                <label className="block text-sm font-medium ">Description</label>
                                <textarea
                                    name="cnc_material_desc"
                                    value={formData.cnc_material_desc}
                                    onChange={handleInputChange}
                                    className="w-full p-2 border rounded"
                                    required
                                ></textarea>
                            </div>

                            <div className="grid grid-cols-2 gap-x-2">
                                <div className="mb-1">
                                    <label className="block text-sm font-medium">Hardening</label>
                                    <input
                                        step="any"
                                        type="number"
                                        name="cnc_hardening"
                                        value={formData.cnc_hardening}
                                        onChange={handleInputChange}
                                        className="w-full p-2 border rounded"
                                        required
                                    />
                                </div>

                                <div className="mb-1">
                                    <label className="block text-sm font-medium mb-1">Hardening scale</label>
                                    <AutoComplete
                                        options={hardeningScaleArray.map((name) => ({ value: name }))}
                                        placeholder="Enter or select a hardening scale"
                                        value={formData.cnc_hardening_scale || ''}
                                        onChange={(value) => {
                                            handleInputChange({
                                                target: {
                                                    name: 'cnc_hardening_scale',
                                                    value,
                                                },
                                            });
                                        }}
                                        filterOption={(inputValue, option) =>
                                            option?.value.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                        className="w-full"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-x-2">
                                <div className="mb-1">
                                    <label className="block text-sm font-medium">Density (g/cm³)</label>
                                    <input
                                        type="number"
                                        name="cnc_material_density_gms_cm3"
                                        value={formData.cnc_material_density_gms_cm3}
                                        onChange={handleInputChange}
                                        className="w-full p-2 border rounded"
                                        required
                                    />
                                </div>
                                <div className="mb-1">
                                    <label className="block text-sm font-medium ">Review Material</label>
                                    <select
                                        name="cnc_material_review"
                                        value={formData.cnc_material_review}
                                        onChange={handleInputChange}
                                        className="w-full p-2 border rounded"
                                        required
                                    >
                                        <option value={false}>False</option>
                                        <option value={true}>True</option>
                                    </select>
                                </div>
                            </div>


                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="bg-gray-300 px-4 py-2 rounded mr-2"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="bg-primaryColor text-white px-4 py-2 rounded"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboardComponents(MaterialMasterComponent);
